import React from "react";
import { FiTarget, FiLayers, FiGlobe, FiTrendingUp } from "react-icons/fi";

function WhyChoose() {
  return (
    <div>
      <div className="w-full home-goal py-24 px-8 md:px-16">
        {/* Heading */}
        <div className="text-center mb-16">
          <p className="text-cyan-400 uppercase tracking-[3px] text-sm font-semibold mb-4">
            Why Choose Us
          </p>

          <h2 className="text-white text-4xl md:text-5xl font-semibold">
            Why Organizations Choose MapleCloud
          </h2>

          <p className="text-gray-400 mt-5 max-w-3xl mx-auto text-lg">
            Purpose-built enterprise software designed for security, operations,
            scalability, and long-term business growth.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Card 1 */}
          <div className="group backdrop-blur-md  bg-blue/20 border border-cyan-500/20 rounded-3xl p-8 hover:-translate-y-3 transition duration-300 hover:border-cyan-400/50 hover:shadow-[0_0_30px_rgba(34,211,238,0.2)]">
            <div className="w-14 h-14 rounded-2xl bg-cyan-500/10 flex items-center justify-center mb-6">
              <FiTarget className="text-cyan-400 text-2xl" />
            </div>

            <h3 className="text-white text-xl font-semibold mb-4">
              Product-First Approach
            </h3>

            <p className="text-gray-400 text-sm leading-relaxed">
              Built around enterprise software platforms instead of generic
              service packaging, ensuring long-term product value.
            </p>
          </div>

          {/* Card 2 */}
          <div className="group backdrop-blur-md  bg-blue/20 border border-cyan-500/20 rounded-3xl p-8 hover:-translate-y-3 transition duration-300 hover:border-cyan-400/50 hover:shadow-[0_0_30px_rgba(34,211,238,0.2)]">
            <div className="w-14 h-14 rounded-2xl bg-cyan-500/10 flex items-center justify-center mb-6">
              <FiLayers className="text-cyan-400 text-2xl" />
            </div>

            <h3 className="text-white text-xl font-semibold mb-4">
              Enterprise Use Cases
            </h3>

            <p className="text-gray-400 text-sm leading-relaxed">
              Coverage across AI-SecOps, monitoring, zero trust access,
              enterprise management, IT operations, and SaaS workflows.
            </p>
          </div>

          {/* Card 3 */}
          <div className="group backdrop-blur-md  bg-blue/20 border border-cyan-500/20 rounded-3xl p-8 hover:-translate-y-3 transition duration-300 hover:border-cyan-400/50 hover:shadow-[0_0_30px_rgba(34,211,238,0.2)]">
            <div className="w-14 h-14 rounded-2xl bg-cyan-500/10 flex items-center justify-center mb-6">
              <FiGlobe className="text-cyan-400 text-2xl" />
            </div>

            <h3 className="text-white text-xl font-semibold mb-4">
              Built in India
            </h3>

            <p className="text-gray-400 text-sm leading-relaxed">
              A focused enterprise software ecosystem aligned with modern
              digital transformation and operational excellence.
            </p>
          </div>

          {/* Card 4 */}
          <div className="group backdrop-blur-md  bg-blue/20 border border-cyan-500/20 rounded-3xl p-8 hover:-translate-y-3 transition duration-300 hover:border-cyan-400/50 hover:shadow-[0_0_30px_rgba(34,211,238,0.2)]">
            <div className="w-14 h-14 rounded-2xl bg-cyan-500/10 flex items-center justify-center mb-6">
              <FiTrendingUp className="text-cyan-400 text-2xl" />
            </div>

            <h3 className="text-white text-xl font-semibold mb-4">
              Scalable Business Value
            </h3>

            <p className="text-gray-400 text-sm leading-relaxed">
              Platforms designed to support growth, modernization, operational
              efficiency, and long-term enterprise control.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhyChoose;
